import { useQuery } from "@tanstack/react-query";
import apiSubscription from "../../services/subscription";

/**
 * Get a single project by ID — derived from the full project list.
 *
 * Why use the list endpoint instead of a dedicated single-project endpoint:
 *  - Project list is small (~10 items), payload is negligible
 *  - React Query caches it for 5min — same cache serves both list view
 *    (landing page) and single view (sidebar in signup)
 *  - One less backend endpoint to maintain
 */
export function useProject({ id_project } = {}) {
  return useQuery({
    queryKey: ["subscription", "projects"],
    queryFn: () => apiSubscription.getProjects(),
    staleTime: 1000 * 60 * 5,
    enabled: !!id_project,
    // Pick out the single project we want
    select: (data) =>
      Array.isArray(data)
        ? data.find((p) => Number(p.id_project) === Number(id_project)) ?? null
        : null,
  });
}